exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".ctitle[data-v-e61ea444]{height:56px;width:100%;text-align:center}", "", {"version":3,"sources":["E:/mywork/math/mathManager/src/pages/knowledgeList.vue"],"names":[],"mappings":"AACA,yBACE,YAAa,AACb,WAAY,AACZ,iBAAmB,CACpB","file":"knowledgeList.vue","sourcesContent":["\n.ctitle[data-v-e61ea444]{\n  height: 56px;\n  width: 100%;\n  text-align: center;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e61ea444","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/knowledgeList.vue
// module id = 588
// module chunks = 5